export default __webpack_public_path__ + "static/media/info-modal-1.f6f32788.png";